import { render, staticRenderFns } from "./InvoiceDocumentsDropzone.vue?vue&type=template&id=20b77c01&scoped=true&"
import script from "./InvoiceDocumentsDropzone.vue?vue&type=script&lang=ts&"
export * from "./InvoiceDocumentsDropzone.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceDocumentsDropzone.vue?vue&type=style&index=0&id=20b77c01&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b77c01",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VImg,VRow})
